/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_MembersInputs */

const en_household_members = /** @type {(inputs: Household_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const de_household_members = /** @type {(inputs: Household_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Household_MembersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const household_members = /** @type {((inputs?: Household_MembersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_MembersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_household_members(inputs)
	return en_household_members(inputs)
});